import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY || process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyCr-xoPU4Fzsen0diDokuTmaeZOjvzx17M",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "batcheet00.firebaseapp.com",
  projectId: process.env.REACT_APP_PROJECT_ID || process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "batcheet00",
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET || process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "bbatcheet00.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "879204222976",
  appId: process.env.REACT_APP_APP_ID || process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:879204222976:web:449a2c1742282be44d70e5",
  databaseURL: process.env.REACT_APP_DATABASE_URL || process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL || "https://batcheet00-default-rtdb.firebaseio.com"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache()
});
export const rtdb = getDatabase(app);
export const storage = getStorage(app);


export default app;
